import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import './App.css';
import "./Fonts.css";

//Components
import NavBar from "./Components/NavBar/NavBar.js";
import Footer from "./Components/Footer/Footer.js";
import Home from "./Components/Home/Home.js";
import About from "./Components/About/About";
import Projects from "./Components/Projects/Projects";


export default class App extends React.Component {

  componentDidMount(){
      console.disableYellowBox = true;
  }
  
  render()
  {
    return (
      <Router>
     
        <div className="appContainer">

            <NavBar />
            <Switch>
          
              <Route exact path="/about" component={About} />
              <Route exact path="/projects" component={Projects} />
              <Route exact path="/" component={Home} />
              
            </Switch>
            <Footer />
        </div>

      </Router>
    );
  }
}